import { jsx as _jsx } from "react/jsx-runtime";
/// <reference types="@tiptap/extension-color" />
import { useRichTextEditorContext } from "../context";
import { FormatColorTextNoBar } from "../icons";
import { MenuButtonColorPicker, } from "./MenuButtonColorPicker";
export default function MenuButtonTextColor({ IconComponent = FormatColorTextNoBar, tooltipLabel = "Text color", defaultTextColor = "", ...menuButtonProps }) {
    const editor = useRichTextEditorContext();
    const currentTextColor = editor === null || editor === void 0 ? void 0 : editor.getAttributes("textStyle").color;
    return (_jsx(MenuButtonColorPicker, { IconComponent: IconComponent, tooltipLabel: tooltipLabel, 
        // If the color is unset, we fall back to the default color
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        value: currentTextColor || defaultTextColor, onChange: (newColor) => {
            editor === null || editor === void 0 ? void 0 : editor.chain().focus().setColor(newColor).run();
        }, disabled: !(editor === null || editor === void 0 ? void 0 : editor.isEditable) || !editor.can().setColor("#000"), ...menuButtonProps, labels: { removeColorButton: "Reset", ...menuButtonProps.labels } }));
}
